module.exports = __webpack_public_path__ + "Flag-166.5769e5d18626b52d4546a1945fa2aaaf.svg";